import { FireRating } from "./FireRating";

interface ListItemProps {
  team: string;
  description: string;
  link: string;
  sauce: string;
}
export const ListItem = ({
  team,
  description,
  link,
  sauce,
}: ListItemProps): JSX.Element => {
  const random = Math.floor(Math.random() * Math.max(5) + 1);

  return (
    <li className={`item flavorCard${random}`}>
      <div className="itemHeaderContainer">
        <h2 className="itemTitle">{team}</h2>
        <FireRating sauce={sauce} />
      </div>
      <p className="itemContent">{description}</p>
      <a href={link} className="readMoreButton">
        Read More
      </a>
    </li>
  );
};
